var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "legal-page" }, [
    _c("div", { staticClass: "legal-container" }, [
      _c(
        "nav",
        { staticClass: "legal-nav" },
        _vm._l(_vm.documents, function (doc) {
          return _c(
            "router-link",
            {
              key: doc.slug,
              staticClass: "legal-nav-item",
              class: { active: doc.slug === _vm.slug },
              attrs: { to: "/" + doc.slug },
            },
            [_vm._v(" " + _vm._s(doc.title) + " ")]
          )
        }),
        1
      ),
      _vm.loading
        ? _c("div", { staticClass: "legal-state" }, [_vm._v("Carregando…")])
        : _vm.error
        ? _c("div", { staticClass: "legal-state" }, [
            _vm._v(" " + _vm._s(_vm.error) + " — escreva para "),
            _c("a", { attrs: { href: "mailto:" + _vm.dpoEmail } }, [
              _vm._v(_vm._s(_vm.dpoEmail)),
            ]),
            _vm._v(". "),
          ])
        : _c("article", { staticClass: "legal-body" }, [
            _c("span", { staticClass: "legal-version" }, [
              _vm._v("Versão " + _vm._s(_vm.document.version)),
            ]),
            _c("div", {
              staticClass: "legal-content",
              domProps: { innerHTML: _vm._s(_vm.document.content_html) },
            }),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }